import React from 'react';
import { ArrowRightIcon, GiftIcon, SparklesIcon, TicketIcon } from 'lucide-react';
interface OffersEngagementCardsProps {
  onOpenCoupons: () => void;
  onOpenSpin: () => void;
  onOpenScratch: () => void;
}
const previewCoupons: Array<{
  code: string;
  label: string;
  tone: string;
}> = [{
  code: 'SAVE20',
  label: '20% OFF',
  tone: 'border-rose-200 bg-rose-50 text-rose-800'
}, {
  code: 'WELCOME10',
  label: '10% OFF',
  tone: 'border-sky-200 bg-sky-50 text-sky-800'
}, {
  code: 'FREESHIP',
  label: 'FREE DELIVERY',
  tone: 'border-amber-200 bg-amber-50 text-amber-800'
}];
export function OffersEngagementCards({
  onOpenCoupons,
  onOpenSpin,
  onOpenScratch
}: OffersEngagementCardsProps) {
  return <section className="grid w-full gap-4 px-4 lg:grid-cols-3" aria-label="Rewards and coupons" data-id="element-4380" data-mp="3ikdl0ktdfk9j">
      <button type="button" onClick={onOpenCoupons} className="group flex min-h-[275px] flex-col rounded-2xl border border-brand-border bg-white p-5 text-left shadow-sm transition-[box-shadow,border-color] duration-150 hover:border-sage hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 md:p-6" data-id="element-4381" data-mp="34l5ibhy01u0l">
        <div className="flex items-start justify-between gap-4" data-id="element-4382" data-mp="24au8l16qhvby">
          <div className="flex items-center gap-3" data-id="element-4383" data-mp="24881f2nr9hu9">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-light text-brand" data-id="element-4384" data-mp="1zcspwhd7zy10">
              <TicketIcon className="h-5 w-5" aria-hidden="true" data-id="element-4385" data-mp="1bm6j0teycjsl" />
            </span>
            <div data-id="element-4386" data-mp="16o52af500wka">
              <p className="text-xs font-bold uppercase tracking-wide text-sage-dark" data-id="element-4387" data-mp="16on19jj1povw">Save more today</p>
              <h2 className="mt-0.5 text-xl font-bold text-gray-900" data-id="element-4388" data-mp="1ldt2te5cvr6y">Your available coupons</h2>
            </div>
          </div>
          <span className="rounded-full bg-sage-light px-2.5 py-1 text-xs font-bold text-sage-dark" data-id="element-4389" data-mp="sv5msd57v2cq">4 offers</span>
        </div>

        <div className="mt-5 grid gap-2.5 sm:grid-cols-3" data-id="element-4390" data-mp="nv9i0bop36w4">
          {previewCoupons.map(coupon => <div key={coupon.code} className={`rounded-xl border p-3 ${coupon.tone}`} data-id="element-4391" data-mp="1djon4vnyusf2">
              <p className="text-[11px] font-bold tracking-wide" data-id="element-4392" data-mp="1hl046csry5bn">{coupon.label}</p>
              <p className="mt-2 truncate font-mono text-sm font-black tracking-tight" data-id="element-4393" data-mp="1mc9tfcaev6n0">{coupon.code}</p>
            </div>)}
        </div>

        <div className="mt-auto flex items-center justify-between border-t border-gray-100 pt-4" data-id="element-4394" data-mp="1rb3652hvitm4">
          <p className="text-sm text-gray-600" data-id="element-4395" data-mp="unf1nnaqizl1">Choose a code and apply it at checkout.</p>
          <span className="ml-3 inline-flex shrink-0 items-center gap-1 text-sm font-bold text-brand" data-id="element-4396" data-mp="ynpgzqkf32ck">
            View all
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-4397" data-mp="13od4i29ft121" />
          </span>
        </div>
      </button>

      <button type="button" onClick={onOpenSpin} className="group relative flex min-h-[275px] flex-col overflow-hidden rounded-2xl border border-brand-dark bg-brand p-5 text-left text-white shadow-sm transition-shadow duration-150 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 md:p-6" data-id="element-4398" data-mp="2f0xhffmjoa49">
        <div className="flex items-start justify-between gap-4" data-id="element-4399" data-mp="3urgjdoarx6sh">
          <div className="flex items-center gap-3" data-id="element-4400" data-mp="3pu7znj9z8up4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white" data-id="element-4401" data-mp="3ptes4g37215x">
              <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-4402" data-mp="3lpqjdu2tszj3" />
            </span>
            <div data-id="element-4403" data-mp="3grp1vdl1t89q">
              <p className="text-xs font-bold uppercase tracking-wide text-white/70" data-id="element-4404" data-mp="3gvcqpzfjt6i4">A surprise offer</p>
              <h2 className="mt-0.5 text-xl font-bold text-white" data-id="element-4405" data-mp="36uu3qvsot9vz">Spin & Win</h2>
            </div>
          </div>
          <span className="rounded-full border border-white/25 bg-white/10 px-2.5 py-1 text-xs font-bold text-white" data-id="element-4406" data-mp="1a2ah0cgybh6f">Free spin</span>
        </div>

        <div className="mt-5 flex items-center justify-between gap-5" data-id="element-4407" data-mp="153z39qnjcmix">
          <div data-id="element-4408" data-mp="1d56rhj0rcwxa">
            <p className="max-w-[185px] text-sm leading-6 text-white/85" data-id="element-4409" data-mp="1d5gfx265mw0v">
              Spin the wheel for a chance to unlock an exclusive discount.
            </p>
            <div className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-white px-3 py-2 text-sm font-bold text-brand" data-id="element-4410" data-mp="136h97p4y9agi">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-4411" data-mp="183r59nmugkdb" />
              Start your spin
            </div>
          </div>
          <span className="relative flex h-24 w-24 shrink-0 items-center justify-center rounded-full border-4 border-white bg-[#F6C945] shadow-lg" aria-hidden="true" data-id="element-4412" data-mp="ubkrg875yph1">
            <span className="absolute inset-y-0 left-1/2 w-1 -translate-x-1/2 bg-[#D85B5B]" data-id="element-4413" data-mp="kgsqqviabmi1" />
            <span className="absolute inset-x-0 top-1/2 h-1 -translate-y-1/2 bg-[#65A5D9]" data-id="element-4414" data-mp="pfm3umtntbho" />
            <span className="absolute inset-3 rotate-45 border-y-4 border-[#F0E9D4]" data-id="element-4415" data-mp="bfulk9w418xv" />
            <span className="relative flex h-9 w-9 items-center justify-center rounded-full border-2 border-white bg-brand text-xs font-black text-white" data-id="element-4416" data-mp="fgmwd7kmrlw9">%</span>
          </span>
        </div>

        <div className="mt-auto flex items-center justify-between border-t border-white/20 pt-4" data-id="element-4417" data-mp="3nyxan2zzm0c6">
          <p className="text-sm text-white/80" data-id="element-4418" data-mp="5talnw0t8pv3">One free spin per visit.</p>
          <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-4419" data-mp="to6vi5c31k6" />
        </div>
      </button>

      <button type="button" onClick={onOpenScratch} className="group flex min-h-[275px] flex-col rounded-2xl border border-amber-200 bg-[#FFFBEB] p-5 text-left shadow-sm transition-[box-shadow,border-color] duration-150 hover:border-amber-300 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 md:p-6" data-id="element-4420" data-mp="fpnllbmy7zya">
        <div className="flex items-start justify-between gap-4" data-id="element-4421" data-mp="yhy99y917rbt">
          <div className="flex items-center gap-3" data-id="element-4422" data-mp="tj4ve4pu1yb4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#FDE68A] text-amber-800" data-id="element-4423" data-mp="tg8zelxjpjpb">
              <SparklesIcon className="h-5 w-5" aria-hidden="true" data-id="element-4424" data-mp="3rbwwxo00cxso" />
            </span>
            <div data-id="element-4425" data-mp="3r9kd15aowdcz">
              <p className="text-xs font-bold uppercase tracking-wide text-amber-800" data-id="element-4426" data-mp="5vq5rn2sqcu">Instant reward</p>
              <h2 className="mt-0.5 text-xl font-bold text-gray-900" data-id="element-4427" data-mp="4wvo907xlegx">Scratch & Win</h2>
            </div>
          </div>
          <span className="rounded-full bg-white px-2.5 py-1 text-xs font-bold text-amber-800 shadow-sm" data-id="element-4428" data-mp="9udnfyw5cfbq">1 card</span>
        </div>

        <div className="mt-5 flex min-h-[108px] items-center rounded-xl border-2 border-dashed border-amber-300 bg-white px-4" data-id="element-4429" data-mp="esoygcy6gvvj">
          <div className="w-full text-center" data-id="element-4430" data-mp="nv7vuhj72gae">
            <p className="text-sm font-bold text-gray-900" data-id="element-4431" data-mp="ntwvyssvdsok">Your mystery offer is ready</p>
            <p className="mt-1 text-sm text-gray-600" data-id="element-4432" data-mp="2kojholnqkouz">Scratch to reveal your discount.</p>
            <span className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-[#F6C945] px-3 py-2 text-sm font-bold text-amber-950" data-id="element-4433" data-mp="2plrsu2agvsmq">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-4434" data-mp="2i4d4roh59o2a" />
              Reveal offer
            </span>
          </div>
        </div>

        <div className="mt-auto flex items-center justify-between border-t border-amber-200 pt-4" data-id="element-4435" data-mp="28cz6fk0xiuaq">
          <p className="text-sm text-gray-600" data-id="element-4436" data-mp="23efije2rz8fq">A new surprise awaits.</p>
          <ArrowRightIcon className="h-5 w-5 text-amber-800 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-4437" data-mp="23cb6u9ymx54w" />
        </div>
      </button>
    </section>;
}